import type { RequestHandler } from 'msw';
import type { SetupWorker } from 'msw/browser';
import type { App, InjectionKey } from 'vue';

import { createWorker, startWorker, isMswEnabled } from './browser';

export const MSW_WORKER_KEY = Symbol('msw-worker') as InjectionKey<SetupWorker>;

export interface MswSetupOptions {
  /** Vue app instance - required for provide/inject (worker provided to MockedRequestsDisplay) */
  app: App;
  /** Handler modules to use. Called lazily to avoid pulling app code into lib bundle. */
  handlers: () => Promise<{ handlers: RequestHandler[] }>;
}

export async function setupMsw(options: MswSetupOptions): Promise<boolean> {
  if (!isMswEnabled()) {
    return false;
  }

  const { app, handlers } = options;
  const { handlers: handlerList } = await handlers();
  const worker = await createWorker(handlerList);
  app.provide(MSW_WORKER_KEY, worker);
  return startWorker(worker);
}
